import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Card from 'components_v2/common/CardV2/Card';
import s from './toipRowLayout.scss';
// import CrosswordDiscovery from './crosswordDiscovery';

const TpLeadRightColumn = ({ item, userData }) => {
  let componentReturned;
  return (
    <div className={`${s.rightWrapper} rightCard`}>
      {Array.isArray(item) &&
        item.length > 0 &&
        item.map(el => {
          switch (el.tn) {
            case 'tplead_col_4_list_inner': {
              componentReturned =
                Array.isArray(el?.items) &&
                el?.items.length > 0 &&
                el.items.map(element => (
                  <Card
                    key={element.id}
                    data={element}
                    showDescription
                    isVerticalTile
                    timeStampHtml
                    imgWidth={328}
                    istoipListing
                    isVertical
                    isHomeListing
                    gaPageName="TOIPlus_HomePage"
                    tpPageName="toiphome"
                    userData={userData}
                    // hideDescription={
                    //   crosswordData && Object.keys(crosswordData).length > 0
                    //     ? index !== 1
                    //     : true
                    // }
                    shouldNotlazyloadImage={
                      el.isLead === 'featured' || el.isSubLead === 'subfeatured'
                    }
                  />
                ));

              break;
            }
            // case 'crossworddiscovery': {
            //   componentReturned = <CrosswordDiscovery />;
            //   break;
            // }
            default: {
              componentReturned = (
                <Card
                  key={el.id}
                  data={el}
                  showDescription
                  isVerticalTile
                  timeStampHtml
                  imgWidth={328}
                  istoipListing
                  isVertical
                  isHomeListing
                  gaPageName="TOIPlus_HomePage"
                  tpPageName="toiphome"
                  userData={userData}
                  shouldNotlazyloadImage={
                    el.isLead === 'featured' || el.isSubLead === 'subfeatured'
                  }
                />
              );
            }
          }
          return componentReturned;
        })}
    </div>
  );
};
const mapStateToProps = state => ({
  crosswordData: state.toiplushome.crosswordData,
});

export default connect(mapStateToProps)(TpLeadRightColumn);

TpLeadRightColumn.propTypes = {
  item: PropTypes.arrayOf(PropTypes.object),
  userData: PropTypes.shape({}),
};

TpLeadRightColumn.defaultProps = {
  item: [],
  userData: undefined,
};
